import "./template.css";

const Template = ({ children, variant = "market" }) => {
  const className = `grid-container grid-container--${variant}`;
  return <div className={className}>{children}</div>;
};

export default Template;